import type { ReactNode } from "react";

export type NoticeKind = "info" | "success" | "warning" | "error" | "danger" | "neutral";

const BANNER_KIND: Record<NoticeKind, string> = {
  info: "banner",
  success: "banner banner--success",
  warning: "banner banner--warning",
  error: "banner banner--danger",
  danger: "banner banner--danger",
  neutral: "banner banner--neutral",
};

/**
 * A message about the page: the design system's Banner (it draws the kind's icon).
 * A bold first line, then the text; marked-up text (paragraphs, lists) gets its space (.prose).
 * Info and success are polite live regions (role="status"); errors are announced
 * at once (role="alert").
 */
export function Notice({ kind = "info", title, children }: { kind?: NoticeKind; title?: ReactNode; children?: ReactNode }) {
  const plainText = typeof children === "string";
  return (
    <div className={BANNER_KIND[kind]} role={kind === "error" || kind === "danger" ? "alert" : "status"}>
      {title ? <p className="banner__title">{title}</p> : null}
      {children ? <div className={plainText ? "banner__text" : "banner__text prose"}>{children}</div> : null}
    </div>
  );
}
